import * as React from 'react';
import { Col, Row } from 'reactstrap';
import Page from '../Page';

const CourtReportingReports = (props: any) => {

    return (
        <React.Fragment>
            <Page>
                <Row>
                    <Col>
                        <h2>Coming Soon</h2>
                    </Col>
                </Row>
            </Page>
        </React.Fragment>
    );
}

export default CourtReportingReports;